import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import { PROVIDER_SOURCE, getGitFixedBusinessActivitiesMap, getOtherTypeOfOperationList, getTypeOfOperationList, sortTheCoveragesOrder, useQuotePriceDetailInfo } from '@jove-frontend/uikit';
import { Box } from '@mui/material';
import FooterView from '../policyCompare/footer';
import BasicInfoView from './basicInfo';
import CoverageListView from './coverageList';
import PriceInfoView from './priceInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PriceComparisonOnlyJoveView = function PriceComparisonOnlyJoveView(props) {
  var info = props.info,
      valueChange = props.valueChange,
      defaultCountry = props.defaultCountry,
      disableSwitchCountry = props.disableSwitchCountry,
      hideCountry = props.hideCountry;

  var _useState = useState([]),
      coverageList = _useState[0],
      setCoverageList = _useState[1];

  var _useState2 = useState(null),
      priceInfo = _useState2[0],
      setPriceInfo = _useState2[1];

  var _useQuotePriceDetailI = useQuotePriceDetailInfo(),
      generateQuotePriceSummaryInfoList = _useQuotePriceDetailI.generateQuotePriceSummaryInfoList;
  /**
   * effects
   */


  useEffect(function () {
    if (info !== null && info !== void 0 && info.jove_quote_price) {
      updateQuotePriceInfo();
    }
  }, [info]);
  /**
   * methods
   */

  var updateQuotePriceInfo = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _quoteDetailsInfo$pay, _quoteDetailsInfo$pay3;

      var jove_quote_price, quoteDetailsInfo, newList, _getGitFixedBusinessA, _getGitFixedBusinessA2, _quoteDetailsInfo$pay2, _ref2, _ref2$find;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              jove_quote_price = info.jove_quote_price, quoteDetailsInfo = info.quoteDetailsInfo;
              newList = generateQuotePriceSummaryInfoList(jove_quote_price);
              newList = sortTheCoveragesOrder(newList, {
                orderKey: 'key'
              });
              newList.forEach(function (item) {
                item.coverageText = "Liability coverage level: ".concat(item.coverageText);
              });

              if ([PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(quoteDetailsInfo === null || quoteDetailsInfo === void 0 ? void 0 : (_quoteDetailsInfo$pay = quoteDetailsInfo.payload) === null || _quoteDetailsInfo$pay === void 0 ? void 0 : _quoteDetailsInfo$pay.providerCode)) {
                newList.push({
                  title: 'Coverage Type:',
                  coverageText: ((_getGitFixedBusinessA = getGitFixedBusinessActivitiesMap()) === null || _getGitFixedBusinessA === void 0 ? void 0 : (_getGitFixedBusinessA2 = _getGitFixedBusinessA[quoteDetailsInfo === null || quoteDetailsInfo === void 0 ? void 0 : (_quoteDetailsInfo$pay2 = quoteDetailsInfo.payload) === null || _quoteDetailsInfo$pay2 === void 0 ? void 0 : _quoteDetailsInfo$pay2.businessActivity]) === null || _getGitFixedBusinessA2 === void 0 ? void 0 : _getGitFixedBusinessA2.label) || '-'
                });
              } else if ([PROVIDER_SOURCE().GREATEAMERICAN.value].includes(quoteDetailsInfo === null || quoteDetailsInfo === void 0 ? void 0 : (_quoteDetailsInfo$pay3 = quoteDetailsInfo.payload) === null || _quoteDetailsInfo$pay3 === void 0 ? void 0 : _quoteDetailsInfo$pay3.providerCode)) {
                newList.push({
                  title: 'Coverage Type:',
                  coverageText: ((_ref2 = [].concat(_toConsumableArray(getTypeOfOperationList()), _toConsumableArray(getOtherTypeOfOperationList()))) === null || _ref2 === void 0 ? void 0 : (_ref2$find = _ref2.find(function (item) {
                    var _quoteDetailsInfo$pay4;

                    return item.value === (quoteDetailsInfo === null || quoteDetailsInfo === void 0 ? void 0 : (_quoteDetailsInfo$pay4 = quoteDetailsInfo.payload) === null || _quoteDetailsInfo$pay4 === void 0 ? void 0 : _quoteDetailsInfo$pay4.typeOfOperation);
                  })) === null || _ref2$find === void 0 ? void 0 : _ref2$find.label) || '-'
                });
              } else {
                newList.push({
                  title: 'Geographic limitation:',
                  coverageText: 'Worldwide including USA and Canada'
                });
              }

              setCoverageList(newList);
              setPriceInfo(jove_quote_price);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function updateQuotePriceInfo() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs(Box, {
    className: "relative flex flex-col rounded-[20px] bg-[#EBEFFE]",
    children: [/*#__PURE__*/_jsx(BasicInfoView, {
      className: "p-5",
      valueChange: valueChange,
      defaultCountry: defaultCountry,
      disableSwitchCountry: disableSwitchCountry,
      hideCountry: hideCountry,
      info: info
    }), !!priceInfo && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Box, {
        className: "h-px bg-white"
      }), /*#__PURE__*/_jsx(CoverageListView, {
        className: "p-5",
        list: coverageList
      }), /*#__PURE__*/_jsx(Box, {
        className: "h-px bg-white"
      }), /*#__PURE__*/_jsx(PriceInfoView, {
        className: "p-5",
        info: priceInfo
      }), /*#__PURE__*/_jsx(FooterView, {
        info: info
      })]
    })]
  });
};

export default PriceComparisonOnlyJoveView;